import React from 'react';
import AdminIntro from './AdminIntro/AdminIntro';
import AdminStream from './AdminStream/AdminStream';
import AdminNav from './AdminNav/AdminNav';
import AdminSideMenu from './AdminSideMenu/AdminSideMenu';
import AdminLangCapt from './AdminLangCapt/AdminLangCapt';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import AdminLangTrans from './AdminLangTrans/AdminLangTrans';
import EventsView from './EventsView/EventsView';
import LangView from './LangView/LangView';
import Helmet from 'react-helmet'
import MemAct from './MemAct/MemAct';
import Members from './Members/Members';
import NoticePost from './NoticePost/NoticePost';


const Admin = () => {

    return (
        
        <Router>
            <div className="admin-background hide"></div>
            <div className="lang-background hide"></div>
            
            <div>
                
                <AdminNav />
                <main className='content-view'>
                    <AdminSideMenu />
                    <div className="admin-body">
                        <AdminIntro />
                        <div className='admin-main'>
                            <Switch>
                                <Route path='/lvcconnectreact/admin' exact>

                                </Route>

                                <Route path='/lvcconnectreact/admin/s2text' >
                                    <AdminStream />
                                    <AdminLangCapt />
                                </Route>

                                <Route path='/lvcconnectreact/admin/s2trans' >
                                    <AdminStream />
                                    <AdminLangTrans />
                                </Route>

                                <Route path='/lvcconnectreact/admin/languages' component={LangView} />
                                <Route path='/lvcconnectreact/admin/members' component={Members} />
                                <Route path='/lvcconnectreact/admin/memact' component={MemAct} />
                                <Route path='/lvcconnectreact/admin/events' component={EventsView} />
                                <Route path='/lvcconnectreact/admin/notice' component={NoticePost} />
                            </Switch>
                            
                        </div>
                        <footer className='admin-footer'>
                            <p>Made with ❤️ by Virtual Church Team. LVZ Connect! A Group Church of CELVZ © 2021. All rights reserved.</p>
                        </footer>
                    </div>
                </main>
            </div>
        </Router>
    )
}

export default Admin